/* eslint-disable */ 
import React, { useState } from 'react';
import { useStateValue } from '../ContextApi/StateProvider';
import { Link, Redirect } from 'react-router-dom';
import Form from './Form';
import './components.css';

const SignUp = (props) => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [password, setPassword] = useState("");
    const [errors, setErrors] = useState([]);
    const [initialState] = useStateValue();
    const authUser = initialState.authenticatedUser;

    const change = (event, setState) => {
        const value = event.target.value;
        setState(value);
    };

    const submit = async () => {
        const user = { firstName, lastName, emailAddress, password };

        await initialState.UserRequests.createUser(user)
            .then((err) => {
                if (err.length) {
                    console.log(err);
                    setErrors([...errors, err]);
                } else {
                    initialState.signIn(emailAddress, password)
                        .then(() => {
                            <Redirect to="/home" />;
                        });
                    console.log(`${emailAddress} successfully signed up and authorized!`);
                }
            })
            .catch((err) => {
                console.log(err.message);
            });
    };

    const cancel = () => {
        props.history.push('/sign-in');
    };

    if (authUser) {
        return <Redirect to="/home" />;
    }

    return (
        <div className="sign-up-container">
            <div className="card-2025 p-6 sm:p-8 animate-fade">
                <div className="form-card"><Form
                    cancel={cancel}
                    submit={submit}
                    cancelButtonText="Cancel"
                    submitButtonText="Sign Up"
                    elements={() => (
                        <>
                            <h2 className="form-header">
                                Sign Up <i className="fas fa-user-plus"></i>
                            </h2>

                            {errors.map((error, i) => (
                                <p key={i} className="sign-up-error-message">{error}</p>
                            ))}

                            <div className="form-row">
                                <label htmlFor="firstName" className="form-label">First Name</label>
                                <input
                                    id="firstName"
                                    name="firstName"
                                    type="text"
                                    onChange={(e) => change(e, setFirstName)}
                                    placeholder={firstName}
                                    required
                                    className="sign-up-form-input"
                                />
                            </div>

                            <div className="form-row">
                                <label htmlFor="lastName" className="form-label">Last Name</label>
                                <input
                                    id="lastName"
                                    name="lastName"
                                    type="text"
                                    onChange={(e) => change(e, setLastName)}
                                    placeholder={lastName}
                                    required
                                    className="sign-up-form-input"
                                />
                            </div>

                            <div className="form-row">
                                <label htmlFor="email" className="form-label">Email Address</label>
                                <input
                                    id="email"
                                    name="emailAddress"
                                    type="email"
                                    onChange={(e) => change(e, setEmailAddress)}
                                    placeholder={emailAddress}
                                    required
                                    className="sign-up-form-input"
                                />
                            </div>

                            <div className="form-row">
                                <label htmlFor="password" className="form-label">Password</label>
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    onChange={(e) => change(e, setPassword)}
                                    placeholder={password}
                                    required
                                    className="sign-up-form-input"
                                />
                            </div>

                            <p className="sign-in-prompt">
                                Already have an account?{" "}
                                <Link to="/sign-in" className="sign__link">Click here</Link> to sign in!
                            </p>
                        </>
                    )}
                />
            </div>
            </div>
        </div>
    );
};

export default SignUp;